<template>
    <!-- 商品入库 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielIntoWarehouse')">
            <template slot="header">
                <a-tabs type="card" v-model="tabKey">
                    <a-tab-pane :key="0" tab="单个商品入库记录">
                        <a-form :form="filterForm1" layout="inline" class="store-one-form">
                            <a-form-item label="商品编号">
                                <a-input style="width:100%;" placeholder="请输入" v-decorator="['goodsNo']"></a-input>
                            </a-form-item>
                            <a-form-item label="商品名称">
                                <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                            </a-form-item>
                            <a-form-item label="商品条形码">
                                <a-input placeholder="请输入" v-decorator="['goodsBarCode']"></a-input>
                            </a-form-item>
                            <a-form-item label="入库仓库">
                                <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                            </a-form-item>
                            <a-form-item label="入库日期">
                                <a-range-picker v-decorator="['date']" style="width: 100%;" showTime></a-range-picker>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button type="primary" @click="search1" :loading="searchLoading1">筛选</a-button>
                                <a-button @click="handleReset1()" :loading="searchLoading1">重置</a-button>
                                <a-button type="primary" @click="selfGoodsInWarehouseRecordExport" :loading="exportLoading1">导出</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane v-model="tabKey" :key="1" tab="商品批量导入记录">
                        <a-form :form="filterForm2" layout="inline" class="store-one-form">
                            <a-form-item label="文件名称">
                                <a-input style="width:100%;" placeholder="请输入" v-decorator="['fileName']"></a-input>
                            </a-form-item>
                            <a-form-item label="导入操作人">
                                <a-input placeholder="请输入" v-decorator="['uploadUserName']"></a-input>
                            </a-form-item>
                            <a-form-item label="入库仓库">
                                <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                            </a-form-item>
                            <a-form-item label="导入日期">
                                <a-range-picker v-decorator="['date']" style="width: 100%;" showTime></a-range-picker>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button type="primary" @click="search2" :loading="searchLoading2">筛选</a-button>
                                <a-button @click="handleReset2()" :loading="searchLoading2">重置</a-button>
                                <a-button type="primary" @click="selfGoodsUploadRecordExport" :loading="exportLoading2">导出</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane v-model="tabKey" :key="2" tab="退款退货记录">
                        <a-form :form="filterForm3" layout="inline" class="store-one-form">
                            <a-form-item label="退货客户">
                                <a-input style="width:100%;" placeholder="请输入" v-decorator="['customerPhone']"></a-input>
                            </a-form-item>
                            <a-form-item label="入库仓库">
                                <a-select :options="warehouseOptions" placeholder="请选择" v-decorator="['warehouseId']"></a-select>
                            </a-form-item>
                            <a-form-item label="操作票台">
                                <a-select :options="ticketPlatformOptions" placeholder="请选择" v-decorator="['ticketPlatformId']"></a-select>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button type="primary" @click="search3" :loading="searchLoading3">筛选</a-button>
                                <a-button @click="handleReset3()" :loading="searchLoading3">重置</a-button>
                                <a-button type="primary" @click="selfGoodsReturnedRecordExport" :loading="exportLoading3">导出</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                </a-tabs>
            </template>
            <div v-show="tabKey === 0" class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="goMaterielAdd">单个商品入库</a-button>
                </div>
                <a-table
                bordered
                :dataSource="dataSource1"
                :columns="columns1"
                :pagination="pagination1"
                :rowKey="record => record.id"
                :loading="searchLoading1"
                @change="changePage1"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}} 
                    </template>
                    <template slot="empty" slot-scope="key, row, index">
                        {{key || "-"}}
                    </template>
                    <template slot="actions" slot-scope="key,row">
                        <template v-if="getBtnByAuth('updateStorage')">
                            <a v-if="true" class="text-primary" @click="goDetail(row.goodsId)">商品详情</a>
                            <span v-else class="text-disabled">商品详情</span>
                        </template>
                    </template>
                </a-table>
            </div>
            <div v-show="tabKey === 1" class="wrap-container-in">
                <div class="mb16">
                    <a-button type="primary" @click="goMaterielImport">商品批量导入</a-button>
                </div>
                <a-table
                bordered
                :dataSource="dataSource2"
                :columns="columns2"
                :pagination="pagination2"
                :rowKey="record => record.id"
                :loading="searchLoading2"
                @change="changePage2"
                class="wrap-table"
                >
                    <template slot="index" slot-scope="key, row, index">
                        {{index + 1}}
                    </template>
                    <template slot="actions" slot-scope="key, row">
                        <template>
                            <a v-if="true" class="text-primary" :href="row.uploadUrl" :download="`${row.createTime}_上传.xlsx`">导入文件下载</a>
                            <span v-else class="text-disabled">导入文件下载</span>
                        </template>
                    </template>
                </a-table>
            </div>
            <div v-show="tabKey === 2" class="wrap-container-in">
                <a-table
                bordered
                :dataSource="dataSource3"
                :columns="columns3"
                :pagination="pagination3"
                :rowKey="record => record.id"
                :loading="searchLoading3"
                @change="changePage3"
                class="wrap-table"
                >
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    const columns1 = [
        {
            title: '编号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '入库日期',
            dataIndex: 'createTime'
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            scopedSlots: { customRender: 'warehouseLevel' }
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '库存单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '入库数量',
            dataIndex: 'goodsNum'
        },
        {
            title: '入库仓库',
            dataIndex: 'warehouseName'
        },
        {
            title: '备注',
            dataIndex: 'remark'
        },
        {
            title: '操作',
            dataIndex: 'goodsId',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    const columns2 = [
        {
            title: '序号',
            scopedSlots: { customRender: 'index' }
        },
        {
            title: '导入日期',
            dataIndex: 'createTime'
        },
        {
            title: '文件名称',
            dataIndex: 'fileName'
        },
        {
            title: '导入操作人',
            dataIndex: 'uploadUserName'
        },
        {
            title: '入库仓库',
            dataIndex: 'warehouseName'
        },
        {
            title: '备注',
            dataIndex: 'remark'
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'actions' }
        },
    ];
    const columns3 = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo'
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '入库仓库',
            dataIndex: 'warehouseName'
        },
        {
            title: '入库数量',
            dataIndex: 'goodsNum'
        },
        {
            title: '退货客户',
            dataIndex: 'customerPhone'
        },
        {
            title: '操作票台',
            dataIndex: 'ticketPlatformName'
        },
        {
            title: '操作人',
            dataIndex: 'applyUserName'
        },
        {
            title: '操作时间',
            dataIndex: 'applyTime'
        },
        {
            title: '操作备注',
            dataIndex: 'remark'
        },
        {
            title: '审核人',
            dataIndex: 'approvalUserName'
        },
        {
            title: '审核通过时间',
            dataIndex: 'approvalTime'
        },
    ];
    export default {
        name: 'materielIntoWarehouse',
        components: {},
        props: {},
        data() {
            return {
                columns1,
                columns2,
                columns3,
                dataSource1: [],
                dataSource2: [],
                dataSource3: [],
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination3: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                searchLoading1: false,
                searchLoading2: false,
                searchLoading3: false,
                exportLoading1: false,
                exportLoading2: false,
                exportLoading3: false,
                tabKey: 0,
                warehouseOptions: [],
                ticketPlatformOptions: []
            };
        },
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage1(page) {
                this.pagination1.pageSize = page.pageSize;
                this.pagination1.current = page.current;
                this.selfGoodsInWarehouseRecord();
            },
            // 重置筛选
            handleReset1() {
                this.filterForm1.resetFields();
                this.search1();
            },
            search1() {
                this.pagination1.current = 1;
                this.selfGoodsInWarehouseRecord();
            },
            changePage2(page) {
                this.pagination2.pageSize = page.pageSize;
                this.pagination2.current = page.current;
                this.getUploadRecord();
            },
            // 重置筛选
            handleReset2() {
                this.filterForm2.resetFields();
                this.search2();
            },
            search2() {
                this.pagination2.current = 1;
                this.getUploadRecord();
            },
            changePage3(page) {
                this.pagination3.pageSize = page.pageSize;
                this.pagination3.current = page.current;
                this.getSelfGoodsReturnedRecord();
            },
            // 重置筛选
            handleReset3() {
                this.filterForm3.resetFields();
                this.search3();
            },
            search3() {
                this.pagination3.current = 1;
                this.getSelfGoodsReturnedRecord();
            },
            /**
             * @goMaterielAdd 跳转单个商品入库
             */
            goMaterielAdd() {
                this.$router.push({name: 'materielAdd'});
            },
            /**
             * @goDetail 跳转详情
             */
            goDetail(id) {
                this.$router.push({name: 'materielGoodsDetail', params: {id}});
            },
            /**
             * @goMaterielImport 跳转商品批量导入
             */
            goMaterielImport() {
                this.$router.push({name: 'materielImport'});
            },
            /**
             * @getWarehouseList 获取门店下仓库列表
             */
            getWarehouseList() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.selfWarehousePage({
                    body: {
                        shopId: this.shopId,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.warehouseName;
                            item.value = item.id;
                        });
                        this.warehouseOptions = res.data;
                    }
                });
            },
            /**
             * @cashPayPlatform 获取门店下票台列表
             */
            cashPayPlatform() {
                if (!this.shopId) {
                    return false;
                }
                this.$api.ticketDesk.cashPayPlatform({
                    body: {
                        pageNum: 1,
                        pageSize: 999999,
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res && res.data) {
                        res.data.forEach(item => {
                            item.label = item.name;
                            item.value = item.id;
                        });
                        this.ticketPlatformOptions = res.data;
                    }
                })
            },
            /**
             * @selfGoodsInWarehouseRecord 单个商品入库记录
             */
            selfGoodsInWarehouseRecord() {
                if (!this.shopId || this.searchLoading1) {
                    return false;
                }
                this.filterForm1.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.inWarehouseTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.inWarehouseTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.searchLoading1 = true;
                    this.$api.newStorage.selfGoodsInWarehouseRecord({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            pageNum: this.pagination1.current,
                            pageSize: this.pagination1.pageSize
                        }
                    }).then(res => {
                        if (res && res.data) {
                            this.dataSource1 = res.data;
                        }
                        this.pagination1.total = res.total;
                        this.searchLoading1 = false;
                    }).catch(err => {
                        this.searchLoading1 = false;
                    });
                });
            },
            /**
             * @selfGoodsInWarehouseRecordExport 单个商品入库记录导出
             */
            selfGoodsInWarehouseRecordExport() {
                this.filterForm1.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.inWarehouseTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.inWarehouseTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.exportLoading1 = true;
                    this.$api.newStorage.selfGoodsInWarehouseRecordExportAll({
                        body: {
                            ...values,
                            shopId: this.shopId
                        },
                    }, {
                        responseType: 'blob'
                    }).then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        let downloadUrl = window.URL.createObjectURL(blob);
                        let name = `单个商品入库记录(${this.$moment().format('LLL')}导出).xlsx`
                        a.setAttribute("href", downloadUrl);
                        a.setAttribute("download", name);
                        a.click();
                        this.exportLoading1 = false;
                    }).catch(err => {
                        this.exportLoading1 = false;
                    });
                });
            },
            /**
             * @getUploadRecord 批量商品导入记录
             */
            getUploadRecord() {
                if (!this.shopId || this.searchLoading2) {
                    return false;
                }
                this.filterForm2.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.uploadTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.uploadTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.searchLoading2 = true;
                    this.$api.newStorage.selfUploadRecord({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            pageNum: this.pagination2.current,
                            pageSize: this.pagination2.pageSize
                        }
                    }).then(res => {
                        if (res && res.data) {
                            this.dataSource2 = res.data;
                        }
                        this.pagination2.total = res.total;
                        this.searchLoading2 = false;
                    }).catch(err => {
                        this.searchLoading2 = false;
                    });
                });
            },
            /**
             * @selfGoodsUploadRecordExport 商品批量导入记录
             */
            selfGoodsUploadRecordExport() {
                this.filterForm2.validateFields((errors, values) => {
                    if (errors) return;
                    if (Boolean(values.date) && Boolean(values.date.length)) {
                        values.uploadTimeStart = values.date[0].format('YYYY-MM-DD HH:mm:ss');
                        values.uploadTimeEnd = values.date[1].format('YYYY-MM-DD HH:mm:ss');
                    }
                    delete values.date;
                    this.exportLoading2 = true;
                    this.$api.newStorage.selfGoodsUploadRecordExportAll({
                        body: {
                            ...values,
                            shopId: this.shopId
                        },
                    }, {
                        responseType: 'blob'
                    }).then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        let downloadUrl = window.URL.createObjectURL(blob);
                        let name = `商品批量导入记录(${this.$moment().format('LLL')}导出).xlsx`
                        a.setAttribute("href", downloadUrl);
                        a.setAttribute("download", name);
                        a.click();
                        this.exportLoading2 = false;
                    }).catch(err => {
                        this.exportLoading2 = false;
                    });
                });
            },
            /**
             * @getSelfGoodsReturnedRecord 退货退款记录
             */
            getSelfGoodsReturnedRecord() {
                if (!this.shopId || this.searchLoading3) {
                    return false;
                }
                this.filterForm3.validateFields((errors, values) => {
                    if (errors) return;
                    this.searchLoading3 = true;
                    this.$api.newStorage.selfGoodsReturnedRecord({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            pageNum: this.pagination3.current,
                            pageSize: this.pagination3.pageSize
                        }
                    }).then(res => {
                        if (res && res.data) {
                            this.dataSource3 = res.data;
                        }
                        this.pagination3.total = res.total;
                        this.searchLoading3 = false;
                    }).catch(err => {
                        this.searchLoading3 = false;
                    });
                });
            },
            /**
             * @selfGoodsReturnedRecordExport 退款退货记录
             */
            selfGoodsReturnedRecordExport() {
                this.filterForm3.validateFields((errors, values) => {
                    if (errors) return;
                    this.exportLoading3 = true;
                    this.$api.newStorage.selfGoodsReturnedRecordExportAll({
                        body: {
                            ...values,
                            shopId: this.shopId
                        },
                    }, {
                        responseType: 'blob'
                    }).then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        let downloadUrl = window.URL.createObjectURL(blob);
                        let name = `退款退货记录(${this.$moment().format('LLL')}导出).xlsx`
                        a.setAttribute("href", downloadUrl);
                        a.setAttribute("download", name);
                        a.click();
                        this.exportLoading3 = false;
                    }).catch(err => {
                        this.exportLoading3 = false;
                    });
                });
            },
        },
        beforeCreate() {
            this.filterForm1 = this.$form.createForm(this);
            this.filterForm2 = this.$form.createForm(this);
            this.filterForm3 = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.cashPayPlatform();
            this.getWarehouseList();
            this.selfGoodsInWarehouseRecord();
            this.getUploadRecord();
            this.getSelfGoodsReturnedRecord();
        },
        watch: {
            '$route'(val) {
                // val.name == 'storageIndex' && this.warehouseList();
            },
            'shopId'() {
                this.pagination1.current = 1;
                this.pagination2.current = 1;
                this.pagination3.current = 1;
                this.cashPayPlatform();
                this.getWarehouseList();
                this.getUploadRecord();
                this.selfGoodsInWarehouseRecord();
                this.getSelfGoodsReturnedRecord();
            }
        }
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
